import { Typography } from '@mui/material';

const EmptyDataGridCell = ({ placeholder = '--' }) => (
  <Typography sx={{ textAlign: 'center', width: '100%' }}>{placeholder}</Typography>
);

export default EmptyDataGridCell;
